import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';

import { ROLE_QUERY_KEYS } from './keys';

import * as userService from 'services/user';

const EMPTY_ROLES: string[] = [];

type UserRolesQueryResult = Awaited<ReturnType<typeof userService.fetchRoles>>;

type MyRoleQueryOptions = Omit<UseQueryOptions<UserRolesQueryResult, Error, string[]>, 'queryKey' | 'queryFn'>;

export const useMyRoleQuery = (userId?: number, options?: MyRoleQueryOptions): UseQueryResult<string[], Error> => {
  const enabled = Boolean(userId) && (options?.enabled ?? true);

  return useQuery<UserRolesQueryResult, Error, string[]>({
    queryKey: [ROLE_QUERY_KEYS.MY_ROLE, userId],
    queryFn: () => userService.fetchRoles(userId ?? 0),
    select: (data) =>
      data.roles?.map((item) => item.name).filter((item): item is string => Boolean(item)) || EMPTY_ROLES,
    ...options,
    enabled,
  });
};
